import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.migrationStatuses.query.gql"
import type {
  PlanMigrationStatusesQuery,
  PlanMigrationStatusesQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.migrationStatuses.query"

export function usePlanMigrationStatusesQuery(
  options?: QueryHookOptions<
    PlanMigrationStatusesQuery,
    PlanMigrationStatusesQueryVariables
  >,
) {
  return useQuery<
    PlanMigrationStatusesQuery,
    PlanMigrationStatusesQueryVariables
  >(query, options)
}
